// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3amgh","label":"Labeled_label__1cT4f","divider":"Labeled_divider__2PH6Y"};